
import { getBenchmarkData } from './benchmark/dataProcessor';
import { getAllUniqueProducts } from './benchmark/productService';

export * from './benchmark/types';

export const benchmarkDataService = {
  getBenchmarkData,
  getAllUniqueProducts,
};
